// Canonical accent palette for *inline / dynamic* styles only — chart fills,
// framer-motion props, conditional colors — where a Tailwind token class can't
// reach. For static styles, use the Tailwind token class instead (see
// DESIGN_SYSTEM.md §1). Each value mirrors a token where one exists.
//
// Only conflict-free, reused names live here. Names whose value differs per
// file (AMBER, MUTED, RED, DIM) are intentionally kept local to each file.

export const SAGE   = '#b0ceae' // = token `primary`
export const TERRA  = '#ffb59b' // = token `secondary`
export const BLUE   = '#93c5fd'
export const PURPLE = '#c4b5fd'
export const GREEN  = '#86efac'
export const TEXT   = '#e4e2e0' // = token `on-surface`
